// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionCode, PermissionCodeSchema } from 'api/gen/PermissionCode';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PermissionComment, PermissionCommentSchema } from 'api/gen/PermissionComment';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  code: PermissionCodeSchema,
  comment: t.union([PermissionCommentSchema, t.null]),
  discriminatorId: PositiveIntegerSchema,
  userEnable: t.boolean,
});

export const UpdatePermissionSchema = excess(requiredPart);

export interface UpdatePermission extends t.TypeOf<typeof UpdatePermissionSchema> {}
